export default __webpack_public_path__ + "images/0x777ecd9a05d4640133f6112f3aa777f1ed5acace.png";